function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M10.7019 25.1042H25.6005V3.89636H10.7013C10.3711 3.89636 10.103 3.62833 10.103 3.29807V1.09487C10.103 0.764616 10.3711 0.496582 10.7013 0.496582H28.4017C28.732 0.496582 29 0.764616 29 1.09487V27.9051C29 28.2354 28.732 28.5034 28.4017 28.5034H10.7019C10.3714 28.5034 10.1036 28.2354 10.1036 27.9051V25.7025C10.1036 25.3717 10.3711 25.1042 10.7019 25.1042Z",
  fill: "#001B5B"
}), React.createElement("path", {
  d: "M0.175673 14.0771L8.22925 6.02416C8.45361 5.7995 8.85087 5.7998 9.07523 6.02416L10.9859 7.93509C11.2195 8.16872 11.2195 8.54744 10.9859 8.78107L7.34827 12.4193H23.0956C23.4258 12.4193 23.6938 12.6873 23.6938 13.0176V15.9827C23.6938 16.3129 23.4258 16.581 23.0956 16.581H7.34737L10.985 20.2192C11.2186 20.4528 11.2186 20.8315 10.985 21.0652L9.07434 22.9764C8.96216 23.0886 8.80959 23.1517 8.65135 23.1517C8.4925 23.1517 8.34054 23.0886 8.22836 22.9764L0.174776 14.9234C0.0625973 14.8112 -0.000522614 14.6587 -0.000522614 14.5004C-0.00022316 14.3413 0.0634937 14.1893 0.175673 14.0771Z",
  fill: "#001B5B"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("path", {
  d: "M29 0H0V29H29V0Z",
  fill: "white"
})));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.528cd557.svg";
export { ForwardRef as ReactComponent };